import React from "react";
import Button from "./Button";

// ---------------------------------------------------------------------------
// Code → human-readable display map
// Covers: feature= prop (manager name string) and code= prop (error code string)
// ---------------------------------------------------------------------------
const CODE_MAP = {
  // Error code callers (code= prop)
  PLAN_TYPE_NOT_ENTITLED:   { gateName: "Plan Not Available",      reason: "This plan type is not included in your current subscription. Contact your account manager to add it." },
  FEATURE_NOT_ENTITLED:     { gateName: "Feature Not Available",   reason: "This feature is not included in your current subscription. Contact your account manager to upgrade." },
  TIER_NOT_ENTITLED:        { gateName: "Tier Upgrade Required",   reason: "This feature requires a higher subscription tier. Contact your account manager to upgrade." },
  DRAW_FEATURE_UNAVAILABLE: { gateName: "Draw Plans Unavailable",  reason: "Draw plan management is not included in your current subscription. Contact your account manager." },

  // Feature name callers (feature= prop) — manager display names
  "Accelerator Caps":                  { gateName: "Accelerator Caps Unavailable",         reason: "Accelerator cap configuration is not available on your current plan." },
  "channel_compensation":              { gateName: "Channel Compensation Unavailable",      reason: "Channel compensation requires the Enterprise tier. Contact your account manager." },
  "territory_compensation":            { gateName: "Territory Compensation Unavailable",    reason: "Territory compensation requires the Enterprise tier. Contact your account manager." },
  "margin_compensation":               { gateName: "Margin Compensation Unavailable",       reason: "Margin compensation requires the Enterprise tier. Contact your account manager." },
  "Channel / Co-Sell Compensation":    { gateName: "Co-Sell Compensation Unavailable",      reason: "Co-sell compensation requires the Enterprise tier. Contact your account manager." },
};

const DEFAULT_GATE = {
  gateName: "Feature Unavailable",
  reason:   "This feature is not available on your current plan. Contact your account manager.",
};

export default function GateStatusBanner({
  // Explicit props (legacy / direct callers)
  gateName,
  reason,
  resolveLabel,
  onResolve,
  // Shorthand props used by manager components
  code,
  feature,
}) {
  // Resolve display values — explicit props take priority, then code/feature lookup, then default
  const lookup = CODE_MAP[code] ?? CODE_MAP[feature] ?? DEFAULT_GATE;
  const displayName   = gateName    ?? lookup.gateName;
  const displayReason = reason      ?? lookup.reason;
  const displayLabel  = resolveLabel ?? "Contact support";

  return (
    <div className="flex items-center justify-between rounded-md border border-[rgb(var(--color-warning))] bg-[rgb(var(--color-surface))] p-4">
      <div>
        <div className="text-tok-base font-medium text-[rgb(var(--color-warning))]">{displayName}</div>
        <div className="text-tok-sm text-[rgb(var(--color-text-muted))]">{displayReason}</div>
      </div>
      {onResolve && (
        <Button variant="secondary" onClick={onResolve}>{displayLabel}</Button>
      )}
    </div>
  );
}
